export default __webpack_public_path__ + "static/media/RightWall.5a1fe1ca.glb";